import { Loading } from "@app/components";
import { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { useMasterTables } from "../utils/useMasterTables";
import { errorAlert } from "@app/utils/alerts";
import pathRoutes from "../../../routes/pathRoutes";
import {
  useAnalysisTypes,
  useEquipment,
  useInstallation,
  useIsotopos,
  useSamplingPoints,
  useTypeSample,
} from "@services/servicesGenericsTables";
import { useBackground } from "@app/pages/background/utils/useBackground";

export default function LayoutEditMasterTable() {
  const [loading, setLoading] = useState<boolean>(true);
  const navigate = useNavigate();
  const { fetchAll: fetchAllInstallation } = useInstallation();
  const { fetchAll: fetchAllIsotopos } = useIsotopos();
  const { fetchAll: fetchAllPoints } = useSamplingPoints();
  const { fetchAll: fetchAllTypeSample } = useTypeSample();
  const { fetchAll: fetchEquipment } = useEquipment();
  const { fetchAll: fetchAllAnalysis } = useAnalysisTypes();
  const { fetchAll: fetchAllBackGround } = useBackground();

  const { nameTable } = useParams();
  if (!nameTable) {
    errorAlert("Tabla no encontrada");
    navigate(pathRoutes.ADMIN_MASTER_TABLES);
  }

  const { fetchSpecificTable } = useMasterTables();

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (nameTable) {
          await Promise.all([
            fetchSpecificTable(nameTable),
            fetchAllInstallation(),
            fetchAllIsotopos(),
            fetchAllPoints(),
            fetchAllTypeSample(),
            fetchEquipment(),
            fetchAllAnalysis(),
            fetchAllBackGround(),
          ]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  return loading ? <Loading /> : <Outlet />;
}
